(function(){
  function fresh(){try{var raw=localStorage.getItem('nw_sg_state');if(!raw)return false;var st=JSON.parse(raw);return !!(st&&st.c&&st.a&&(!st.t||Date.now()-st.t<=6048e5));}catch(e){return false;}}
  function inject(){
    try{
      if(!document.querySelector('cart-form'))return;
      if(!fresh())return;
      if(document.getElementById('nw-cart-back'))return;
      var a=document.createElement('a');
      a.id='nw-cart-back';
      a.href='/pages/find-dit-sengetoj?nwresume=1';
      a.innerHTML='&lsaquo; Tilbage til din anbefaling';
      a.style.cssText='display:block;margin:0 auto 10px;font-size:14px;color:#4b5a47;text-decoration:underline;text-underline-offset:3px;text-align:center;font-family:inherit;line-height:1.4';
      var cont=document.querySelector('.continue-shopping');
      if(cont&&cont.parentNode){cont.parentNode.insertBefore(a,cont);return;}
      var head=document.querySelector('.page-header');
      if(head&&head.parentNode){head.appendChild(a);return;}
      var form=document.getElementById('cartform');
      if(form&&form.parentNode){form.parentNode.insertBefore(a,form);return;}
    }catch(e){}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',inject);}else{inject();}
  try{var mo=new MutationObserver(function(){if(!document.getElementById('nw-cart-back'))inject();});mo.observe(document.documentElement,{childList:true,subtree:true});}catch(e){}
  setTimeout(inject,800);setTimeout(inject,2000);
})();
